// Pinia Store
import { defineStore, StateTree } from 'pinia'

import CryptoJS  from 'crypto-js';

interface State {
  filter: Record<string, any>
}

const getPerists = (key: any): any => {
  let pre_value = localStorage.getItem(key) ? localStorage.getItem(key) : null;

  if(!pre_value) {
    return null;
  }

  let decrypted_value = CryptoJS.AES.decrypt(pre_value, import.meta.env.VITE_APP_STORE_SECRET ? import.meta.env.VITE_APP_STORE_SECRET : 'SECRET').toString(CryptoJS.enc.Utf8);

  return JSON.parse(decrypted_value || '{}');
}

const setPerists = (key: any, value: any) => {
  let _value = JSON.stringify(value)
  let encrypted_value = CryptoJS.AES.encrypt(_value, import.meta.env.VITE_APP_STORE_SECRET ? import.meta.env.VITE_APP_STORE_SECRET : 'SECRET').toString()
  localStorage.setItem(key, encrypted_value);
}

export const useFilterStore = defineStore('filter', {
  state: (): State => ({
    filter: getPerists('filter_store') ? getPerists('filter_store') : {},
  }),

  actions: {
    // MUTATIONS

    // ACTIONS
    SET (key:string, value:any) { 
      this.filter[key] = value;

      this.PERSISTS()
    },

    PERSISTS () {
      setPerists('filter_store', this.filter);
    }
  },

  getters: {  },
});
